import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

// used for tailwind className merging (required by shadcn)
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
